// import { Fragment, Node as ProsemirrorNode, NodeType } from 'prosemirror-model';

export function createCell(cellType,cellContent) {
  
  if (cellContent) {
    return cellType.createAndFill(null, cellContent);
  }
 // return cellType.createAndFill({colwidth:[325]});
   return cellType.createAndFill();
}